import React from 'react';

const FormField = ({
  label,
  type = 'text',
  value,
  checked,
  onChange,
  placeholder = '',
  required = false,
  error = '',
  disabled = false,
  className = '',
  style = {},
  helpText = '',
  icon = null,
  labelHint = null,
  ...props
}) => {
  // Colours/border live in .ui-field-input (index.css) rather than inline, so
  // the theme's CSS variables can actually reach them.
  const fieldClass = `ui-field-input${error ? ' ui-field-input--error' : ''}${icon ? ' ui-field-input--with-icon' : ''}`;

  // Wraps the control so an absolutely-positioned leading icon has an anchor.
  const withIcon = (control) => (icon
    ? <span className="ui-field-wrap"><span className="ui-field-icon">{icon}</span>{control}</span>
    : control);

  return (
    <div className={className} style={{ marginBottom: '16px', ...style }}>
      {label && type !== 'checkbox' && (
        <label style={{
          display: 'block',
          fontSize: '14px',
          fontWeight: '500',
          color: 'var(--color-text-secondary)',
          marginBottom: '4px'
        }}>
          {label} {required && <span style={{ color: 'var(--color-danger)' }}>*</span>}
          {labelHint && (
            <span title={labelHint} style={{ marginLeft: 6, color: 'var(--color-text-disabled)', cursor: 'help' }}>&#9432;</span>
          )}
        </label>
      )}
      
      {type === 'textarea' ? (
        <textarea
          className={fieldClass}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          style={{
            resize: 'vertical',
            minHeight: '80px',
          }}
          {...props}
        />
      ) : type === 'select' ? (
        <select
          className={fieldClass}
          value={value}
          onChange={onChange}
          required={required}
          disabled={disabled}
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
          {...props}
        >
          {props.options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : type === 'checkbox' ? (
        <label style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          cursor: disabled ? 'not-allowed' : 'pointer',
          userSelect: 'none'
        }}>
          <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            style={{
              width: '18px',
              height: '18px',
              cursor: disabled ? 'not-allowed' : 'pointer',
              accentColor: 'var(--color-accent)'
            }}
            {...props}
          />
          <span style={{
            fontSize: '14px',
            fontWeight: '500',
            color: disabled ? 'var(--color-text-disabled)' : 'var(--color-text-secondary)'
          }}>
            {label}
          </span>
        </label>
      ) : (
        withIcon(
          <input
            className={fieldClass}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            {...props}
          />
        )
      )}
      
      {error && (
        <p style={{
          color: 'var(--color-danger)',
          fontSize: '12px',
          marginTop: '4px',
          marginBottom: 0
        }}>
          {error}
        </p>
      )}

      {helpText && !error && (
        <p style={{
          color: 'var(--color-text-muted)',
          fontSize: '12px',
          marginTop: '4px',
          marginBottom: 0,
          lineHeight: '1.4'
        }}>
          {helpText}
        </p>
      )}
    </div>
  );
};

export default FormField;